import { BaseSerializer } from "./baseSerializer.ts";

import { ScheduleEntry } from "@models/ScheduleEntry.model.ts";
import { ScheduleSegmentSerializer } from "./scheduleSegmentSerializer.ts";
import { toUtcStartOfDay, toUtcEndOfDay, utcDateToLocalMidnight } from "../../utils/date-utils/scheduleDate.ts";

export class ScheduleEntrySerializer extends BaseSerializer {
  public deserialize(data: any): ScheduleEntry {
    const gp = new ScheduleEntry();
    this._copyAttributes(gp, data);
    if (data.segments) {
      gp.segments = new ScheduleSegmentSerializer().deserializeList(
        data.segments
      );
    }
    if (data.children && data.children.length > 0) {
      gp.children = new ScheduleEntrySerializer().deserializeList(
        data.children
      );
    }

    if (gp.start_time) {
      gp.start_time = utcDateToLocalMidnight(data.start_time);
    }

    if (gp.end_time) {
      gp.end_time = utcDateToLocalMidnight(data.end_time);
    }
    return gp;
  }

  // Date-only fields are pinned to UTC day boundaries so the backend's UTC range covers the whole day.
  public serialize(entry: Partial<ScheduleEntry>): string {
    const payload: any = { ...entry };
    if (entry.start_time != null) payload.start_time = toUtcStartOfDay(entry.start_time);
    if (entry.end_time != null) payload.end_time = toUtcEndOfDay(entry.end_time);
    return JSON.stringify(payload);
  }
}
